import * as React from 'react'
import {Navigate, useLocation} from 'react-router-dom'
import {logError} from '@freckle/student/ts/common/helpers/exception-handlers/bugsnag-client'

export function ErrorRedirect() {
  const location = useLocation()
  logError(new Error(`Invalid URL ${location.pathname}`))
  return <Navigate to={`/${location.pathname}`} replace />
}
